// API Configuration for VestrioZ
const API_CONFIG = {
  // Base URL configuration
  baseURL: process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001'),

  // Timeout configuration
  timeout: 30000, // 30 seconds

  // Environment detection
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',

  // API endpoints
  endpoints: {
    auth: {
      login: '/auth/login',
      signup: '/auth/signup',
      logout: '/auth/logout',
      sendOtp: '/auth/send-otp',
      verifyOtp: '/auth/verify-otp',
      resendOtp: '/auth/resend-otp',
      forgotPassword: '/auth/forgot-password',
      resetPassword: '/auth/reset-password',
      refreshToken: '/auth/refresh-token'
    },
    users: {
      profile: '/users/profile',
      updateProfile: '/users/profile',
      uploadAvatar: '/users/avatar'
    },
    listings: {
      create: '/listings',
      getAll: '/listings',
      getById: '/listings',
      update: '/listings',
      delete: '/listings',
      search: '/listings/search',
      categories: '/listings/categories'
    },
    payments: {
      createOrder: '/payments/create-order',
      verifyPayment: '/payments/verify-payment',
      getTransactions: '/payments/transactions'
    },
    chat: {
      getChats: '/chat',
      getMessages: '/chat/messages',
      sendMessage: '/chat/send'
    },
    contact: {
      send: '/contact/send'
    }
  },

  // Error messages
  errorMessages: {
    network: 'Network error. Please check your internet connection.',
    server: 'Server error. Please try again later.',
    unauthorized: 'Session expired. Please login again.',
    forbidden: 'You do not have permission to perform this action.',
    notFound: 'The requested resource was not found.',
    validation: 'Please check your input and try again.',
    timeout: 'Request timeout. Please try again.'
  }
};

export default API_CONFIG;